/** Shown at the bottom of the About card, so it is easy to see which build a screen is really running. */
export const BUILD = '2026-10-23-m';
